import {app} from "@/app";
import {get, waitFor} from "@/helpers";
import {AbstractShopifyPageObserver} from "@/services/observer/shopify/pages/AbstractShopifyPageObserver";

export class Product extends AbstractShopifyPageObserver {
  isApplicable(): boolean {
    return app.storage.shopify.page.type === app.storage.shopify.page.types.product;
  }

  async resolve() {
    app.debug('Shopify Event: Page: Product: started');

    // wait for shopify to load
    await waitFor(() => get(window, 'ShopifyAnalytics.meta.product', null) != null, 500)
      .then(delay => {
        if(delay == 0) return;
        app.debug('Shopify Event: Page: Product: waited for ShopifyAnalytics.meta.product successfully', delay);
      })
      .catch((delay) => {
        app.debug('Shopify Event: Page: Product: waited for ShopifyAnalytics.meta.product unsuccessfully', delay, 'warn');
      });

    const product = app.storage.shopify.product.payload;
    if (!product) {
      app.debug('Shopify Event: Page: Product: product is missing', null, 'warn');
      return;
    } else {
      app.debug('Shopify Event: Page: Product: product', product);
    }

    // send payload
    await app.pixel.events.shopify.viewContent.handle({
      content_type: 'product',
      ...app.storage.shopify.product.payload ?? {}
    });
  }

}
